//*Libraries imports
import { Loader2, CreditCard } from "lucide-react";

interface AwaitingApprovalModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AwaitingApprovalModal({ isOpen }: AwaitingApprovalModalProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 backdrop-blur-sm p-4">
      <div className="w-full max-w-xs bg-white rounded-2xl p-6 flex flex-col items-center justify-center gap-6 shadow-xl animate-in fade-in zoom-in duration-200">
        <span className="text-gray-500 font-medium text-sm text-center">
          Aguardando aprovação...
        </span>

        <div className="relative flex items-center justify-center size-48">
          {/* Animated Rays Background */}
          <div className="absolute inset-0 flex items-center justify-center animate-spin-slow">
            <svg width="100%" height="100%" viewBox="0 0 170 170" fill="none">
              {Array.from({ length: 16 }).map((_, i) => {
                const angle = (i * 360) / 16;
                const opacity = 0.35 + (i % 4) * 0.12;
                return (
                  <rect
                    key={`ray-${i}`}
                    x={84}
                    y={8}
                    width={2}
                    height={18 + (i % 4) * 3}
                    rx={1}
                    fill="#1777CF"
                    opacity={opacity}
                    transform={`rotate(${angle} 85 85)`}
                  />
                );
              })}
            </svg>
          </div>

          {/* Center Icon */}
          <div className="relative z-10 flex items-center justify-center animate-pulse-slow">
            <div className="size-24 rounded-full bg-[#1777CF] flex items-center justify-center shadow-lg shadow-blue-200">
              <CreditCard size={40} className="text-white" />
            </div>
          </div>

          {/* Loading Spinner overlay */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <Loader2
              className="size-full text-blue-100/20 animate-spin"
              strokeWidth={1}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
